import { isEmpty } from 'lodash';

export default {
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  municipiosColeta(state) {
    return state.municipiosColeta;
  },
  municipiosEntrega(state) {
    return state.municipiosEntrega;
  },
  estadosColeta(state) {
    return state.estadosColeta;
  },
  estadosEntrega(state) {
    return state.estadosEntrega;
  },
  peso(state) {
    return state.peso;
  },
  valorMercadoria(state) {
    return state.valorMercadoria;
  },
  selectedSort(state) {
    return state.selectedSort;
  },
  selectedStatusText(state) {
    if (state.selectedStatus && state.selectedStatus.id === 'MEUS_LOCAIS') {
      return 'true';
    }
    return 'false';
  },
  hasAdvancedFilters(data) {
    return (data.peso || data.valorMercadoria
      || !isEmpty(data.municipiosColeta) || !isEmpty(data.estadosColeta)
      || !isEmpty(data.municipiosEntrega) || !isEmpty(data.estadosEntrega));
  },
  sort(data) {
    if (!data.selectedSort) {
      return 'order by createdIn desc';
    }
    return `order by ${data.selectedSort.value}`;
  },
  stringFilter(state) {
    const filters = ['situacao not in ("FINALIZADA", "CANCELADA")'];
    if (state.valorMercadoria) {
      filters.push(`valorMercadoria > ${state.valorMercadoria}`);
    }
    if (state.peso) {
      filters.push(`pesoTotal > ${state.peso}`);
    }
    if (!isEmpty(state.municipiosColeta)) {
      const ids = state.municipiosColeta.map((m) => m.id);
      filters.push(`municipioColeta in (${ids.join((', '))})`);
    }
    if (!isEmpty(state.municipiosEntrega)) {
      const ids = state.municipiosEntrega.map((m) => m.id);
      filters.push(`municipioEntrega in (${ids.join((', '))})`);
    }
    if (!isEmpty(state.estadosColeta)) {
      const ids = state.estadosColeta.map((m) => m.id);
      filters.push(`estadoColeta in (${ids.join((','))})`);
    }
    if (!isEmpty(state.estadosEntrega)) {
      const ids = state.estadosEntrega.map((m) => m.id);
      filters.push(`estadoEntrega in (${ids.join((','))})`);
    }
    return filters.join(' and ').trim();
  },
  query(state, getters) {
    return `${getters.stringFilter} ${getters.sort}`.trim();
  },
};
